import BuildListItem from 'components/ManualAnalysisList/BuildListItem'
import React from 'react'
import ApplicantInfo from 'components/ApplicantInfo'

import Container from './styles'

function ReviewAnalysis(props) {
  const { checkType, reviewData } = props
  const key = checkType === false ? 'background_check' : 'reference_check'
  
  return (
    <Container>
      <ApplicantInfo applicantData={reviewData[key]?.person} creationDate={reviewData[key]?.created} />
      
      <BuildListItem issue={reviewData} checkType={checkType === false ? 'bgc' : 'rfc'} />
    </Container>
  )
}

export default ReviewAnalysis
